export type UserData = {
  AuthorityType: string;
  ClientId: string;
  Environment: string;
  HomeAccountId: string;
  LocalAccountId: string;
  Name: string;
  TenantId: string;
  Username: string;
};

export type AuthProp = {
  isLoader: boolean;
  token: string;
  role: string;
  userData: UserData;
};

export const initialState: AuthProp = {
  isLoader: false,
  token: '',
  role: '',
  userData: {
    AuthorityType: '',
    ClientId: '',
    Environment: '',
    HomeAccountId: '',
    LocalAccountId: '',
    Name: '',
    TenantId: '',
    Username: '',
  },
};
